import { render, staticRenderFns } from "./TenantEditLegal.vue?vue&type=template&id=6f629c84&scoped=true&"
import script from "./TenantEditLegal.vue?vue&type=script&lang=js&"
export * from "./TenantEditLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f629c84",
  null
  
)

export default component.exports